import styled from 'styled-components';
import { Container, FlexRow, Span } from 'common/styles/oc-styled-components';
import {
  BREAKPOINTS,
  colors,
  FONT_FAMILIES,
  NAV_HEIGHT,
} from 'common/styles/style-constants';

export const NavListItem = styled.li`
  list-style: none;
  display: flex;
  justify-content: center;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    flex: 1;
  }
`;

export const NavButton = styled.button`
  background: ${props =>
    (props.highlighted ? 'rgba(208, 205, 208, 0.1)' : 'transparent')};
  border: none;
  border-bottom: ${props =>
    (props.highlighted ? `3px solid ${colors.blue}` : 'none')};
  display: block;
  padding: 15px;
  height: 100%;
  width: 100%;

  &:focus {
    outline: 0;
  }

  &:hover {
    background: rgba(208, 205, 208, 0.1);
    color: ${colors.charcoal};
    cursor: pointer;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding: 0;
  }
`;

export const NavItem = styled.div`
  align-items: center;
  display: flex;
  font-size: 16px;

  justify-content: center;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    display: block;
    font-size: 12px;
  }
`;

export const NavTitle = styled(Span)`
  font-size: 16px;
  font-weight: 600;
  font-family: ${FONT_FAMILIES.circular};
  display: block;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    font-size: 14px;
  }
`;

export const NavWrapper = styled(FlexRow)`
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.silver};
  border-top: 1px solid ${colors.silver};
  height: ${NAV_HEIGHT}px;
  margin: 0 -200%;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    justify-content: center;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin: 0;
  }
`;

export const StyledContainer = styled(Container)`
  padding-left: 205px;

  @media (max-width: ${BREAKPOINTS.widescreenMin}px) {
    padding-left: 170px;
  }

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    padding-left: 0;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    max-width: 100vw;
    overflow: hidden;
  }
`;
